import { render, staticRenderFns } from "./cv-h5.vue?vue&type=template&id=287b46fa&scoped=true"
import script from "./cv-h5.vue?vue&type=script&lang=ts"
export * from "./cv-h5.vue?vue&type=script&lang=ts"
import style0 from "./cv-h5.vue?vue&type=style&index=0&id=287b46fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b46fa",
  null
  
)

export default component.exports